import { render, staticRenderFns } from "./EdInputEditor.vue?vue&type=template&id=b5cbcf56&"
import script from "./EdInputEditor.vue?vue&type=script&lang=js&"
export * from "./EdInputEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports